import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { ListFieldSection } from '../../../../../Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../../Core';

let AsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const applyCorrection = useSelector(
    pipe(createWorksheetSelector!('Preparation.ApplyCorrection'), valueOrDefault(false))
  );
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection>
        <Field input={<TextOutput />} name="Results.UncorrectedMoisturePercent" visible={applyCorrection} />
        <Field
          input={<TextOutput />}
          name="Results.MoistureContentPercent"
          label={applyCorrection ? 'Corrected Moisture Content' : 'Moisture Content'}
        />
      </ListFieldSection>
    </>
  );
};

AsResultsSection = withInjectedProps(AsResultsSection);

export { AsResultsSection };
export default AsResultsSection;
